import React from "react";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import OfferIcon from "@components/icons/Offer";
import { Button } from "@components/buttons";
import { useTranslation } from "react-i18next";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function ChannelInfoContainer() {
	const { chatViewStore } = useRootAppStore();
	const { t } = useTranslation();

	const channelInfo = chatViewStore.chatChannelHandler.iconProps;

	if (!chatViewStore.chatChannelHandler.activeChannelInfo) {
		//if no info return empty div
		return <div></div>;
	}

	const { displayName, memberCount } =
		chatViewStore.chatChannelHandler.activeChannelInfo;

	return (
		<>
			<ErrorBoundaryWithPropagation
				componentName={"Mobile/ChannelInfoContainer.tsx"}
			>
				<Button
					className="btn--square btn--square--xtny btn--ghost btn--icon--left"
					onClick={() => chatViewStore.toggleChatList(true)}
					iconClassName="u-icon u-icon--tny u-icon--arrow-left"
					iconLeft
				/>

				<div className="chat__header__wrapper">
					<div className="chat__icon">
						{channelInfo?.sportAbrv &&
							!channelInfo?.categoryAbrv &&
							!channelInfo?.tournamentAbrv && (
								<OfferIcon
									type="sport"
									sport={channelInfo?.sportAbrv || ""}
									className="chat__icon__primary u-icon u-icon--lrg"
								/>
							)}

						{channelInfo?.sportAbrv &&
							channelInfo?.categoryAbrv &&
							!channelInfo?.tournamentAbrv && (
								<OfferIcon
									type="category"
									sport={channelInfo?.sportAbrv || ""}
									category={channelInfo?.categoryAbrv || ""}
									className="chat__icon__primary u-icon u-icon--lrg"
								/>
							)}

						{channelInfo?.categoryAbrv &&
							channelInfo?.tournamentAbrv &&
							channelInfo?.sportAbrv && (
								<OfferIcon
									type="tournament"
									sport={channelInfo?.sportAbrv || ""}
									category={channelInfo?.categoryAbrv || ""}
									tournament={
										channelInfo?.tournamentAbrv || ""
									}
									className="chat__icon__primary u-icon u-icon--lrg"
									catOverSportClass="chat__icon__secondary u-icon u-icon--xmed"
									mobile={true}
								/>
							)}
					</div>
					<div className="chat__header__title">
						<span className="chat__name">{displayName}</span>
						{memberCount && (
							<span className="chat__subtitle">
								{t("CHAT.MEMBERS")}: {memberCount}
							</span>
						)}
					</div>
				</div>
			</ErrorBoundaryWithPropagation>
		</>
	);
});
